import React, {useEffect, useState} from "react";
import {useCreatePlanMutation} from "../../../../../redux/apiSlice";
import {useSubheader} from "../../../../../_metronic/layout";
import cogoToast from "cogo-toast";
import SafeLockWizard from "../../components/SafeLockWizard";

export const CreatePlan = ({history, location}) => {
    const subheader = useSubheader();
    useEffect(() => {
        subheader.setTitle("Create Safe Lock Plan")
    }, [subheader])

    const [tab, setTab] = useState(1);

    const [
        createPlan, // This is the mutation trigger
        {
            isLoading: isCreating,
            isSuccess: createdSuccessfully,
        }, // This is the destructured mutation result
    ] = useCreatePlanMutation()

    /* Clear fields on success */
    useEffect(() => {
        if (createdSuccessfully) {
            cogoToast.success("Created 'Safe Lock Creation' Action Successfully")
            setTab(1)
            history.push("/overview/safeLocks/create")
        }
    }, [history, createdSuccessfully]);

    /* Submit exchange rate data */
    const submitData = async data => {
        createPlan(data);
    }

    return (
        <SafeLockWizard
            key={location.key}
            tab={tab} // Reset Tab on success
            setTab={setTab}
            isLoading={isCreating}
            submitData={submitData}
        />
    )
}